import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/onboarding/_steps/$')({
  beforeLoad: () => {
    throw redirect({
      to: `/onboarding`,
      replace: true,
    });
  },
});
